module.exports = __webpack_public_path__ + "static/media/banner_5CardPoker-half.5d7f649f.png";